'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _dispatcher = require('../../../dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _CallHandler = require('../../../CallHandler');

var _CallHandler2 = _interopRequireDefault(_CallHandler);

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _MatrixClientPeg = require('../../../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _languageHandler = require('../../../languageHandler');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2015, 2016 OpenMarket Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
module.exports = (0, _createReactClass2.default)({
    displayName: 'CallView',

    propTypes: {
        // js-sdk room object. If set, we will only show calls for the given
        // room; if not, we will show any active call.
        room: _propTypes2.default.object,

        // A Conference Handler implementation
        // Must have a function signature:
        //  getConferenceCallForRoom(roomId: string): MatrixCall
        ConferenceHandler: _propTypes2.default.object,

        // maxHeight style attribute for the video panel
        maxVideoHeight: _propTypes2.default.number,

        // a callback which is called when the user clicks on the video div
        onClick: _propTypes2.default.func,

        // a callback which is called when the content in the callview changes
        // in a way that is likely to cause a resize.
        onResize: _propTypes2.default.func,

        // render ongoing audio call details - useful when in LeftPanel
        showVoice: _propTypes2.default.bool
    },

    getInitialState: function getInitialState() {
        return {
            // the call this view is displaying (if any)
            call: null
        };
    },

    componentDidMount: function componentDidMount() {
        this.dispatcherRef = _dispatcher2.default.register(this.onAction);
        this.showCall();
    },

    componentWillUnmount: function componentWillUnmount() {
        _dispatcher2.default.unregister(this.dispatcherRef);
    },

    onAction: function onAction(payload) {
        // don't filter out payloads for room IDs other than props.room because
        // we may be interested in the conf 1:1 room
        if (payload.action !== 'call_state') {
            return;
        }
        this.showCall();
    },

    showCall: function showCall() {
        var call = void 0;

        if (this.props.room) {
            var roomId = this.props.room.roomId;
            call = _CallHandler2.default.getCallForRoom(roomId) || (this.props.ConferenceHandler ? this.props.ConferenceHandler.getConferenceCallForRoom(roomId) : null);

            if (this.call) {
                this.setState({ call: call });
            }
        } else {
            call = _CallHandler2.default.getAnyActiveCall();
            this.setState({ call: call });
        }

        if (call) {
            call.setLocalVideoElement(this.getVideoView().getLocalVideoElement());
            call.setRemoteVideoElement(this.getVideoView().getRemoteVideoElement());
            // always use a separate element for audio stream playback.
            // this is to let us move CallView around the DOM without interrupting remote audio
            // during playback, by having the audio rendered by a top-level <audio/> element.
            // rather than being rendered by the main remoteVideo <video/> element.
            call.setRemoteAudioElement(this.getVideoView().getRemoteAudioElement());
        }
        if (call && call.type === "video" && call.call_state !== "ended" && call.call_state !== "ringing") {
            // if this call is a conf call, don't display local video as the
            // conference will have us in it
            this.getVideoView().getLocalVideoElement().style.display = call.confUserId ? "none" : "block";
            this.getVideoView().getRemoteVideoElement().style.display = "block";
        } else {
            this.getVideoView().getLocalVideoElement().style.display = "none";
            this.getVideoView().getRemoteVideoElement().style.display = "none";
            _dispatcher2.default.dispatch({ action: 'video_fullscreen', fullscreen: false });
        }

        if (this.props.onResize) {
            this.props.onResize();
        }
    },

    getVideoView: function getVideoView() {
        return this.refs.video;
    },

    render: function render() {
        var VideoView = _index2.default.getComponent('voip.VideoView');
        var AccessibleButton = _index2.default.getComponent('elements.AccessibleButton');

        var voice = void 0;
        if (this.state.call && this.state.call.type === "voice" && this.props.showVoice) {
            var callRoom = _MatrixClientPeg2.default.get().getRoom(this.state.call.roomId);
            voice = _react2.default.createElement(
                AccessibleButton,
                { className: 'mx_CallView_voice', onClick: this.props.onClick },
                (0, _languageHandler._t)("Active call (%(roomName)s)", { roomName: callRoom.name })
            );
        }

        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(VideoView, { ref: 'video', onClick: this.props.onClick,
                onResize: this.props.onResize,
                maxHeight: this.props.maxVideoHeight
            }),
            voice
        );
    }
});
//# sourceMappingURL=CallView.js.map